<template>
  <b-carousel
    id="carousel-fade"
    style="text-shadow: 0px 0px 2px #000"
    fade
    img-width="800"
    img-height="480"
  >
    <b-carousel-slide v-for="im in images" v-bind:key="im._id" :img-src="getImagePath(im)"/>
  </b-carousel>
</template>

<script>
import { getImageSrc } from '@/utils/assets';

export default {
  name: 'CarouselSection',
  props: {
    images: Array,
  },
  methods: {
    getImagePath: (image) => getImageSrc(image),
  },
};
</script>

<style scoped>

</style>
